import { useMutation, useQueryClient } from '@tanstack/react-query'
import { onSuccessInvalidate, type InvalidationGroup } from '@/hooks/invalidation'

/** useMutation wrapper for admin mutations that invalidate a group on success. */
export function useAdminMutation<TVar>(mutationFn: (vars: TVar) => Promise<unknown>, group: InvalidationGroup) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn,
    ...onSuccessInvalidate(queryClient, group),
  })
}
